import React from "react";
import styled from "styled-components";
import VideoListEntry from "../VideoListEntry";
import Modal from "../Modal";
import WelcomeMessage from "../WelcomeMessage";
import { Link, useLocation } from "react-router-dom";

import PropTypes from "prop-types";

const Wrapper = styled.div`
  display: grid;
  padding: 2em 0 0;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-template-rows: 200px 200px 200px;
  column-gap: 50px;
  row-gap: 300px;
`;

export default function VideoList({ videos }) {
  const location = useLocation();

  return (
    <>
      <Wrapper>
        {videos.map((video) => {
          return (
            <Link
              style={{ textDecoration: "none", color: "black" }}
              to={`/videos/${video.id.videoId}`}
              state={{
                videoSnippet: video.snippet,
                backgroundLocation: location,
              }}
              key={video.id.videoId}
            >
              <VideoListEntry video={video} />
            </Link>
          );
        })}
      </Wrapper>

      {location.state?.isFirstLoading && (
        <Modal>
          <WelcomeMessage />
        </Modal>
      )}
    </>
  );
}

VideoList.propTypes = {
  videos: PropTypes.array.isRequired,
};
